import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import db from "astrid-firebase/src/db";
import agreementStatuses from "astrid-firestore/src/api/agreements/constants/agreementStatuses";

import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import useAgreementColumns from "../../hooks/useAgreementColumns";

const expiringAgreementsStatuses = [agreementStatuses.SIGNED, agreementStatuses.ACTIVE, agreementStatuses.EXPIRED];

export default function AgreementsExpiringView({ firstPartyId }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const tenDaysFromNow = new Date();
	tenDaysFromNow.setDate(tenDaysFromNow.getDate() + 10);
	tenDaysFromNow.setHours(23, 59, 59, 999);

	const query = db
		.collection("agreements")
		.where("deleted", "==", false)
		.where("firstParty.id", "==", firstPartyId)
		.where("expires", "<=", tenDaysFromNow)
		.where("status", "in", expiringAgreementsStatuses)
		.orderBy("expires", "desc")
		.limit(200);

	const columns = useAgreementColumns();

	return (
		<>
			<div style={{ marginBottom: 15 }}>
				<Header as="h2">{t("expiringAgreements", "Expiring agreements")}</Header>
			</div>

			<CollectionDataTable
				persist
				filterable
				query={query}
				columns={columns}
				onClick={({ id }) => navigate(id)}
				sortBy={{
					id: "time",
					desc: false,
				}}
			/>
		</>
	);
}
